import { cbAdminRoleProps } from '../../../../../../constants/roles';

type HeaderColumn = {
  title: string;
  sortField?: string[];
  className: string;
};

type HeaderUser = {
  rid?: number | string;
} | null;

function getHeaderClass(columnName: string, user: HeaderUser) {
  function classes() {
    if (user?.rid === cbAdminRoleProps.CB_ADMIN_USER_RID) {
      return {
        studentName: 'col-xs-12 col-sm-6 col-md-2',
        accommodations: 'hidden-xs hidden-sm col-md-2',
        attendance: 'hidden-xs hidden-sm col-xs-12 col-md-1',
        dapTestStatus: 'hidden-xs col-xs-12 col-sm-3 col-md-2',
        startTime: 'hidden-xs col-xs-12 col-sm-3 col-md-2',
        estimatedExamEndTime: 'hidden-xs col-xs-12 col-sm-3 col-md-2',
        lastUpdated: 'hidden-xs col-xs-12 col-sm-3 col-md-1 px-lg-1',
      };
    } else {
      return {
        studentName: 'col-xs-12 col-sm-6 col-md-2',
        accommodations: 'hidden-xs hidden-sm col-md-2',
        attendance: 'hidden-xs col-sm-3 col-xs-12 col-md-2',
        dapTestStatus: 'hidden-xs col-xs-12 col-sm-3 col-md-2',
        startTime: 'hidden-xs col-xs-12 col-sm-3 col-md-2',
        estimatedExamEndTime: 'hidden-xs col-xs-12 col-sm-3 col-md-2',
        lastUpdated: 'hidden',
      };
    }
  }

  return classes()[columnName as keyof ReturnType<typeof classes>];
}

export function generateHeaders(user: HeaderUser, showStudentTestSchedule = true) {
  const headers: HeaderColumn[] = [
    {
      title: 'Student',
      sortField: ['candMidInit', 'candFirstName', 'candLastName'],
      className: getHeaderClass('studentName', user),
    },
    { title: 'Accommodations', className: getHeaderClass('accommodations', user) },
    { title: 'Attendance', sortField: ['status.sortOrder'], className: getHeaderClass('attendance', user) },
    { title: 'Testing', sortField: ['dapTestStatus.sortOrder'], className: getHeaderClass('dapTestStatus', user) },
    { title: 'Last Updated', sortField: ['updated'], className: getHeaderClass('lastUpdated', user) },
  ];

  if (showStudentTestSchedule) {
    const lastUpdatedIndex = headers.findIndex((h) => h.title === 'Last Updated');
    const insertAt = lastUpdatedIndex !== -1 ? lastUpdatedIndex : headers.length;
    headers.splice(
      insertAt,
      0,
      {
        title: 'Start Time',
        sortField: ['examStartTime'],
        className: getHeaderClass('startTime', user),
      },
      {
        title: 'Est. End Time',
        sortField: ['estimatedExamEndTime'],
        className: getHeaderClass('estimatedExamEndTime', user),
      }
    );
  }

  return headers;
}
